import React from 'react';

const About = () => {
    return (
        <div>
            <p className='text-center my-5 fs-1' style={{ color: 'blueviolet' }}>Few line about us</p>
            <p className='px-5 fs-4'>This is the Processor Analysis website. We have tried our best to give a review of the best, best quality and fastest processor in the market. In this case we have chosen the processor of amd.
                We may not match your preferences. Don't be sad.
                Thank you for visiting us here.
                Request for advice: </p>
        </div>
    );
};

export default About;